import { Injectable } from "@angular/core";
import { Subject } from "rxjs/Subject";

@Injectable()
export class ApplicationService {
  counterBtnCount = new Subject<any>();
  counterBtnClicked = new Subject<any>();

  constructor() {
    this.nextcounterBtnCount(0);
  }

  nextcounterBtnCount(message: number) {
    this.counterBtnCount.next(message);
  }

  nextCounterBtnClicked(value: boolean) {
    this.counterBtnClicked.next(value);
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/application.service.ts